import React, { useEffect, useState } from 'react';
import {aboutBg} from '../../assets/images';
import Header from '../../Components/Header/Header';
import ServicesDetailItems from './ServicesDetailItems/ServicesDetailItems';
import { useTranslation } from 'react-i18next';
import { useParams } from 'react-router-dom';
import axios from 'axios';
import Breadcrumb from '../../Components/Breadcrumb/Breadcrumb';

const ServicesDetail = () => {
  const { t, i18n } = useTranslation();
  const currentLanguage = i18n.language;
  const { id } = useParams();

  const [singleNews, setSingleNews] = useState(null);
  const [services, setServices] = useState([]);

  useEffect(() => {
    getProducts();
  }, []);

  const getProducts = async () => {
    try {
      const response = await axios.get(
        `https://cortex-site.runasp.net/api/Services`,
        { withCredentials: false }
      );
      setServices(response.data);
      const filteredService = response.data.find(
        (product) => product.id == id
      );
      setSingleNews(filteredService);
    } catch (error) {
      console.error('Error fetching products:', error);
    }
  };

  // Çoklu dil destekleyen alanı güvenli şekilde getiren fonksiyon
  const getLocalizedField = (item, fieldBase) => {
    if (!item) return '';
    if (currentLanguage === 'en') return item[`${fieldBase}En`] || item[fieldBase];
    if (currentLanguage === 'ru') return item[`${fieldBase}Ru`] || item[fieldBase];
    return item[fieldBase]; // Default: az
  };

  return (
    <>
      <div
        className='bg-black/60'
        style={{
          position: 'relative',
          overflow: 'hidden',
          backgroundImage: `url(${aboutBg})`,
          backgroundSize: 'cover',
          backgroundPosition: 'center',
          backgroundRepeat: 'no-repeat',
          width: '100%',
          height: window.innerWidth < 640 ? '250px' : '300px',
        }}
      >
        <Breadcrumb
          title={t('Xidmətlər')}
          content={getLocalizedField(singleNews, 'title')}
        />
      </div>

      <ServicesDetailItems />
    </>
  );
};

export default ServicesDetail;
